import { render, staticRenderFns } from "./NorditropinStatusIcon.vue?vue&type=template&id=379b240b&scoped=true&"
import script from "./NorditropinStatusIcon.vue?vue&type=script&lang=js&"
export * from "./NorditropinStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./NorditropinStatusIcon.vue?vue&type=style&index=0&id=379b240b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379b240b",
  null
  
)

export default component.exports